import * as classNames from 'classnames';
import * as React from 'react';
import {CollabMode} from '../../common/interview-type';

import {
    sidebar   as cssSidebar,
    button    as cssButton,
    buttonOn  as cssButtonOn,
    label     as cssLabel,
    separator as cssSeparator,
} from './collab-sidebar.module.sass';

export class CollabSidebar extends React.Component<any, any> {
    public render(): React.ReactElement<any> {
        const {leftBarHidden, collabMode} = this.props;

        return (
            <div className={cssSidebar}>
                <button
                    className={classNames(cssButton, {
                        [cssButtonOn]: !leftBarHidden
                    })}
                    type='button'
                    onClick={this.toggleLeftBar(!leftBarHidden)}
                >
                    <i className='fa fa-file-text' />
                    <div className={cssLabel}>Content</div>
                </button>
                <hr className={cssSeparator} />
                <button
                    className={cssButton}
                    type='button'
                    disabled={collabMode === CollabMode.Code}
                    onClick={this.setCollabMode(CollabMode.Code)}
                >
                    <i className='fa fa-code' />
                    <div className={cssLabel}>Code</div>
                </button>
                <button
                    className={cssButton}
                    type='button'
                    disabled={collabMode === CollabMode.Video}
                    onClick={this.setCollabMode(CollabMode.Video)}
                >
                    <i className='fa fa-video-camera' />
                    <div className={cssLabel}>Video</div>
                </button>
                {false /* Turned off for white label. */ &&
                    <button
                        className={cssButton}
                        type='button'
                        disabled={collabMode === CollabMode.Screen}
                        onClick={this.setCollabMode(CollabMode.Screen)}
                    >
                        <i className='fa fa-desktop' />
                        <div className={cssLabel}>Peer's<br />Screen</div>
                    </button>
                }
            </div>
        );
    }

    private setCollabMode = state => () => this.props.setCollabMode(state);

    private toggleLeftBar = state => () => this.props.toggleLeftBar(state);
}
